import React, { useEffect, useMemo, useState } from "react";

// Paginación en el navegador para listados largos: el servidor devuelve TODO
// (sin topes, para que los filtros encuentren cualquier fila) y aquí solo se
// pintan `porPagina` filas cada vez. `resetDeps`: lo que al cambiar debe
// volver a la página 1 (los datos y los filtros).
export function usePaginacion(filtradas, resetDeps, porPagina = 100) {
  const [pagina, setPagina] = useState(1);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPagina(1); }, resetDeps);
  const totalPaginas = Math.max(1, Math.ceil(filtradas.length / porPagina));
  const paginaActual = Math.min(pagina, totalPaginas);
  const inicio = (paginaActual - 1) * porPagina;
  const paginaRows = useMemo(() => filtradas.slice(inicio, inicio + porPagina), [filtradas, inicio, porPagina]);
  return { pagina: paginaActual, setPagina, totalPaginas, paginaRows };
}

export function Paginador({ pagina, totalPaginas, onCambiar }) {
  if (totalPaginas <= 1) return null;
  return (
    <div className="paginador">
      <button className="btn btn-mini" disabled={pagina <= 1} onClick={() => onCambiar(1)} title="Primera página">«</button>
      <button className="btn btn-mini" disabled={pagina <= 1} onClick={() => onCambiar(pagina - 1)}>‹ Anterior</button>
      <span className="muted">Página {pagina} de {totalPaginas}</span>
      <button className="btn btn-mini" disabled={pagina >= totalPaginas} onClick={() => onCambiar(pagina + 1)}>Siguiente ›</button>
      <button className="btn btn-mini" disabled={pagina >= totalPaginas} onClick={() => onCambiar(totalPaginas)} title="Última página">»</button>
    </div>
  );
}
